import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IReportGeneratedTableData, ReportGeneratedTableData } from "./reportGeneratedTableData";
import { Base } from "ui/Scripts/source/framework/base";

export interface IReportGenerated2 extends IIdTitle {
    downloadId: string;
    fileName: string;
    content: string;
    mediaType: string;
    listWidth: number;
    tables: IReportGeneratedTableData[];
}

export class ReportGenerated2 extends IdTitle implements IReportGenerated2 {
    downloadId: string;
    fileName: string;
    content: string;
    mediaType: string;
    listWidth: number;
    tables: ReportGeneratedTableData[];
    
    constructor();
    constructor(obj: IReportGenerated2);
    constructor(obj?: any) {
        super(obj);
        this.downloadId = obj && obj.downloadId || "";
        this.fileName = obj && obj.fileName || "";
        this.content = obj && obj.content || "";
        this.mediaType = obj && obj.mediaType || "";
        this.listWidth = obj && obj.listWidth || 0;
        this.tables = Base.getTypedArray(obj ? obj.tables : null, ReportGeneratedTableData);
    }
}